import React, { useState } from 'react'
import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import KeyedCipherTheory from './KeyedCipherTheory';
import KeyedCipherSimulation from './KeyedCipherSimulation';
import KeyedCipherAlgo from './KeyedCipherAlgo';
import KeyedCipherExercise from './KeyedCipherExercise';


const KeyedCipherPage = () => {
    const [value, setValue] = useState(0);
    const [selectedTab, setSelectedTab] = useState("Theory");

    return (
        <div>
            <h1>Keyed Cipher</h1>
            <Paper square style={{ width: "fit-content", minWidth: "100%" }}>
                <Tabs
                    value={value}
                    textColor="primary"
                    indicatorColor="primary"
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                >
                    <Tab label="Theory" onClick={()=>{ setSelectedTab("Theory")}}/>
                    <Tab label="Algorithm" onClick={()=>{ setSelectedTab("Algorithm")}}/>
                    <Tab label="Simulation" onClick={() => {setSelectedTab("Simulation") }} />
                    <Tab label="Exercise" onClick={() => { setSelectedTab("Exercise") }} />
                    {/* <Tab label="Disabled TAB!" disabled /> */}
                </Tabs>
                <div style={{ display: selectedTab === "Theory" ? "inline-block" : "none" }}>
                    <KeyedCipherTheory/> 
                </div>

                <div style={{ display: selectedTab === "Algorithm" ? "inline-block" : "none" }}>
                    <KeyedCipherAlgo/> 
                </div>

                <div style={{ display: selectedTab === "Simulation" ? "inline-block" : "none" }} > 
                    <KeyedCipherSimulation/>
                </div>

                <div style={{ display: selectedTab === "Exercise" ? "inline-block" : "none" }} > 
                    <KeyedCipherExercise/>
                </div>
                
                

            </Paper>
        </div>
    );
}

export default KeyedCipherPage